import getEnhancementFetchers from './fetchers/getEnhancementFetchers';
import { SAVE_TOKEN } from './types';
import { createParameters } from './utils';

function fetchEnhancement(idType, parameters, dispatch) {
  return (enhancementFetcher) => {
    const urlFormatter = enhancementFetcher.urlFormatter[idType];
    if (urlFormatter) {
      const url = urlFormatter(parameters);
      if (url) {
        dispatch(enhancementFetcher.fetch(url));
      }
    }
  };
}

export default function fetchEnhancements() {
  return (dispatch, getState) => {
    const {
      idType,
      metadata,
      pdfContent: { identification },
      token,
      viewConfig: { fetchers },
    } = getState();
    if (token && fetchers.length > 0) {
      const parameters = createParameters(idType, identification, metadata, token);
      if (parameters) {
        getEnhancementFetchers(fetchers)
          .forEach(fetchEnhancement(idType, parameters, dispatch));
      }
    }
  };
}

export function receivedToken(token) {
  return (dispatch) => {
    dispatch({ type: SAVE_TOKEN, payload: token });
    dispatch(fetchEnhancements());
  };
}
